var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTrackSpeed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4_13)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M50.0001 0C22.5 0 0 22.5 0 50.0001C0 77.5002 22.5 100 50.0001 100C77.5002 100 100 77.5002 100 50.0001C100 22.5 77.5 0 50.0001 0Z",
    fill: "#E24C4B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.0001 90.625C27.5001 90.625 9.37506 72.4999 9.37506 49.9999C9.37506 27.4999 27.5001 9.37512 50.0001 9.37512C72.5001 9.37512 90.6251 27.5002 90.6251 50.0002C90.6251 72.5002 72.5001 90.625 50.0001 90.625Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4_13"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrackSpeed);
export default __webpack_public_path__ + "static/media/track-speed.10df7b6be77c00a13f3d080ea586c9ac.svg";
export { ForwardRef as ReactComponent };